import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_IOS_MOBILE, IS_MOBILE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import type { YearAndMonthProductIds } from 'reactApp/modules/products/products.types';

const value: undefined | 'a' | 'b' | 'c' | 'd' | 'e' = IS_MOBILE_BROWSER
    ? getFeature('price-differentiation-mobile')
    : getFeature('price-differentiation');

export const isPriceDifferentiation = Boolean(value) && value !== 'a';

export const isAllowedPriceDiffOverquota: boolean = isFeature('price-differentiation-overquota');

export const priceDiffBasicTariffListDesktop: YearAndMonthProductIds = getFeature('price-diff-basic-tariff-list-desktop');
export const priceDiffAdvancedTariffListDesktop: YearAndMonthProductIds = getFeature('price-diff-advanced-tariff-list-desktop');
export const priceDiffFamilyTariffListDesktop: YearAndMonthProductIds = getFeature('price-diff-family-tariff-list-desktop');
export const priceDiffBusinessTariffListDesktop: YearAndMonthProductIds = getFeature('price-diff-business-tariff-list-desktop');

const priceDiffBasicTariffListIOS: YearAndMonthProductIds = getFeature('price-diff-basic-tariff-list-ios');
const priceDiffBasicTariffListAndroid: YearAndMonthProductIds = getFeature('price-diff-basic-tariff-list-android');
const priceDiffBasicTariffListTouch: YearAndMonthProductIds = getFeature('price-diff-basic-tariff-list-touch');
const priceDiffBasicTariffListWebview: YearAndMonthProductIds = IS_IOS_MOBILE
    ? priceDiffBasicTariffListIOS
    : priceDiffBasicTariffListAndroid;
export const priceDiffBasicTariffListMobile: YearAndMonthProductIds = IS_WEBVIEW
    ? priceDiffBasicTariffListWebview
    : priceDiffBasicTariffListTouch;

const priceDiffAdvancedTariffListIOS: YearAndMonthProductIds = getFeature('price-diff-advanced-tariff-list-ios');
const priceDiffAdvancedTariffListAndroid: YearAndMonthProductIds = getFeature('price-diff-advanced-tariff-list-android');
const priceDiffAdvancedTariffListTouch: YearAndMonthProductIds = getFeature('price-diff-advanced-tariff-list-touch');
const priceDiffAdvancedTariffListWebview: YearAndMonthProductIds = IS_IOS_MOBILE
    ? priceDiffAdvancedTariffListIOS
    : priceDiffAdvancedTariffListAndroid;
export const priceDiffAdvancedTariffListMobile: YearAndMonthProductIds = IS_WEBVIEW
    ? priceDiffAdvancedTariffListWebview
    : priceDiffAdvancedTariffListTouch;

export const priceDiffFamilyTariffListMobile: YearAndMonthProductIds = getFeature('price-diff-family-tariff-list-mobile');

export const priceDiffTariffsMobile: YearAndMonthProductIds = getFeature('price-diff-tariff-list-touch');

export const priceDiffTariffHeaderDesktop =
    getFeature('price-diff-tariff-header-desktop') || 'W1TB_1y_blackfriday_2023_discount_single_quota_cloud';
export const priceDiffTariffHeaderTouch =
    getFeature('price-diff-tariff-header-touch') || 'W256GB_1y_blackfriday_2023_discount_single_quota_cloud';
export const priceDiffTariffUnlimPromo = getFeature('price-diff-tariff-unlim') || 'W1TB_1y_blackfriday_2023_discount_single_quota_cloud';
export const priceDiffTariffFamilyPromo = getFeature('price-diff-tariff-family-promo') || 'W1TB_1y_family_features_a';

// CLOUDWEB-20146 Доработка эксперимента по эластичности
export const priceDiffBusinessTariffListIOS: YearAndMonthProductIds = getFeature('price-diff-business-tariff-list-ios');
export const priceDiffBusinessTariffListAndroid: YearAndMonthProductIds = getFeature('price-diff-business-tariff-list-android');
export const priceDiffBusinessTariffListTouch: YearAndMonthProductIds = getFeature('price-diff-business-tariff-list-touch');
export const priceDiffBusinessTariffListWebview: YearAndMonthProductIds = IS_IOS_MOBILE
    ? priceDiffBusinessTariffListIOS
    : priceDiffBusinessTariffListAndroid;
export const priceDiffBusinessTariffListMobile: YearAndMonthProductIds = IS_WEBVIEW
    ? priceDiffBusinessTariffListWebview
    : priceDiffBusinessTariffListTouch;
